import {lazy} from 'react';

export const availableRoutes = {
    login: lazy(() => import('../Pages/UserPages/Login')),
    dashboards: lazy(() => import('../Pages/Dashboards')),
    register: lazy(() => import('../Pages/UserPages/Register')),
    AdminCustomerUsers: lazy(() => import('../Pages/AdminCustomer/AdminCustomerUsers')),
    forgotPassword: lazy(() => import('../Pages/UserPages/ForgotPassword')),
    resetPassword: lazy(() => import('../Pages/UserPages/ResetPassword'))
};